<template>
  <div class="login-wrapper">
    <div class="container-fluid bg">
      <div class="row justify-content-center align-items-center login overflow-scroll">

        <div class="smartphone-img">
          <img src="../assets/img/tel_appli.png" alt="smartphone-img">
        </div>

        <div class="card border-0 mb-0">

          <!-- Header and logo -->
          <div class="card-header text-center p-t-0">
            <p>
              {{ $t("SignInForm.go_to_signup_begin") }}
              <span class="signup-link">
                <router-link :to="{ name: 'SignUpForm' }">{{ $t("SignInForm.click_here") }}</router-link>
              </span>
              {{ $t("SignInForm.go_to_signup_end") }}
            </p>
            <img class="logo-style img-fluid" src="../assets/img/logo_connexion_ts.png" alt="logo-black" width="250" height="43">
          </div>
          <!-- End of header and logo -->

          <div class="card-body">
          <!-- Top of Form -->
            <form @submit.prevent="signIn" class="p-t-15" role="form" novalidate="novalidate">
              <transition name="slide-fade">
                <div v-if="invalidCredentials" class="alert alert-danger">
                  {{ $t("SignInForm.invalid_credentials") }}
                </div>
              </transition>

              <div class="form-group form-group-default">
                <label>{{ $t("SignInForm.email") }}*</label>
                <div class="controls">
                  <input v-model="user.email" v-validate="'required|email'" type="text" name="email" class="form-control"
                        required="" id="email" aria-required="true">
                </div>
              </div>
              <transition name="slide-fade">
                <label v-show="errors.has('email')" id="email-error" class="error" for="email">{{ errors.first('email')}}</label>
              </transition>

              <div class="form-group form-group-default m-t-25">
                <label>{{ $t("SignInForm.password") }}*</label>
                <div class="controls">
                  <input v-model="user.password" v-validate="'required'" type="password" class="form-control"
                        name="password" required="" id="password" aria-required="true">
                </div>
              </div>
              <transition name="slide-fade">
                <label v-show="errors.has('password')" id="password-error" class="error" for="password">{{
                  errors.first('password') }}</label>
              </transition>

              <div class="row">
                <div class="col-12">
                  <div class="checkbox">
                    <input v-model="user.rememberMe" type="checkbox" id="remember-me">
                    <label for="remember-me">{{ $t("SignInForm.remember_me") }}</label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md">
                  <button class="btn btn-lg btn-primary btn-cons m-t-10 btn-block btn-sign-in" type="submit">
                    {{ $t("SignInForm.signin") }}
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-12 m-t-10 m-b-10">
                  <router-link :to="{ name: 'ForgotPassword' }">{{ $t("SignInForm.forgot_password") }}</router-link>
                </div>
              </div>
            </form>
            <!-- End of form -->
          </div>

          <!-- Form footer -->
          <div class="card-footer bg-transparent mt-5">
            <div class="row justify-content-center text-center">
              <div>
                <a :href=externalLinks.legalNotice class="m-r-10 footer-link" target="_blank">Mentions
                  légales</a>
                <span class="link-separator">|</span>
                <a :href=externalLinks.termsOfService class="m-l-10 m-r-10 footer-link" target="_blank">CGU</a>
                <span class="link-separator">|</span>
                <a :href=externalLinks.privacyPolicy class="m-l-10 footer-link" target="_blank">Politique de confidentialité</a>
                <br>            
                <span class="link-separator">|</span>
                <a :href=externalLinks.support class="m-l-10 m-r-10 footer-link" target="_blank">Support</a>
                <span class="link-separator">|</span>
                <a :href=externalLinks.faq class="m-l-10 footer-link" target="_blank">FAQ</a>
              </div>
            </div>
          </div>
          <!-- End of form footer -->

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { externalLinks } from "../settings/externalLinks";

export default {
  name: 'SignInForm',
  data: function() {
    return ({
      user: {
        email: '',
        password: '',
        rememberMe: false
      },
      invalidCredentials: false
    });
  },
  computed: {
    externalLinks() {
      return externalLinks
    }
  },

  methods: {
    signIn(){
      var self = this;
      this.$validator.validateAll().then((result) => {
        if(result){
          this.$store.dispatch("auth/signIn", this.user).then(() => {
            if (this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect)
            } else {
              this.$router.push("/")
            }
          }).catch(function (error) {
            self.invalidCredentials = true;
          });
        }
      });
    }
  }
}
</script>


<style lang="scss" scoped>
  @import '../assets/scss/pages/_var.scss';
  .footer {
    text-align: center;
    width: 75%;

    a, a:hover {
      color: $color-black;
    }
    .copyright {
      border-top: none;
    }
  }
  .bg {
    background-color: #fff;
  }
  .overflow-scroll {
    overflow: auto;
  }
  .login {
    height: 100vh;
  }
  .card {
    padding: 1rem 1rem 1rem;
  }
  .card-header p {
    text-align: right;
    font-size: 12px;
  }
  .box-message-pending {
    background: #E5F4F5;
    padding: 8px;
    margin-bottom: 15px;
  }
  .box-message-pending a {
    color: #159f92;
  }
  // Overhide default bootstrap style of .card-header a
  .card-header a:not(.btn) {
    color: #e51349 !important;
    opacity: 1 !important;
  }
  .card-header a:hover {
    filter: brightness(70%);
  }
  .btn {
    white-space:normal;
    word-wrap: break-word;
  }
  .link-separator {
    color: $color-black;
  }
  .form-footer {
    position: absolute;
    bottom: 20px;
  }

  @media (max-width: 767px) {
    .card {
      min-height: 100vh;
    }
    .logo-style {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .card-footer {
      position:absolute;
      bottom:0;
      align-self: center;
    }
    .card-body {
      padding: 15px;
    }
    .smartphone-img {
      display: none;
    }
  }

  @media (min-width: 768px) {
    .card {
      padding: 2rem 4rem 2rem;
      border-radius: 15px;
      max-width: 600px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    .card-header {
      padding-right: 0px;
    }
    .bg {
      background: white url('/static/img/signin_form.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      // box-shadow:inset 0 0 0 2000px rgba(0, 0, 0, 0.8);
    }
    .logo-style {
      position: fixed;
      top: 20px;
      left: 20px;
      margin: 0px;
      margin-left: 10px;
      margin-top: 10px;
      width: 350px;
      height: auto;
    }
    .smartphone-img {
      position: fixed;
      bottom: -15px;
      right: -15px;
    }
    .smartphone-img > img {
      height: 450px;
      width: auto;
    }
  }

  @media (min-width: 768px) and (max-width: 1400px) and (orientation: portrait) {
    .logo-style {
      position: fixed;
      top: 20px;
      left: 50%;
      margin: 0px;
      align-content: center;
      transform: translate(-50%);
    }
    .smartphone-img {
      display: none;
    }
  }

  /* avoids logo overlap when tablet is used in landscape orientation */
  @media (min-width: 768px) and (max-width: 1400px) and (orientation: landscape) {
    .logo-style {
      position: static;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .smartphone-img {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SignInForm.vue